module.exports = "<div class=\"aside\" id=\"addShipping\">\n\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-add-shipping/template.html
 ** module id = 325
 ** module chunks = 1
 **/